import script from "./LottScanFail.vue?vue&type=script&setup=true&lang=js"
export * from "./LottScanFail.vue?vue&type=script&setup=true&lang=js"

import "./LottScanFail.vue?vue&type=style&index=0&id=75917548&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75917548"]])

export default __exports__